export default "__VITE_ASSET__BQHJJPFR__"